<div class="container-fluid sell_dash">
  <div class="wrapper">
      <div class="row">
        <app-sidemenu></app-sidemenu> 
        <section class="right">
          <app-sellheader></app-sellheader>
           <div class="right-middle row justify-content-center">
            <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10" id="top-nav" >
              <p class="ph_heading">Total Purchases: {{len}}</p>
                <div class="row card_row" *ngFor="let card_values of purchase_history | paginate: {itemsPerPage:2,currentPage: p}">
                    <div class="col-sm-12 card card-1" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
                        <div class="row">
                            <div class="col-sm-2 img_col">
                              <div class="img-square-wrapper">
                                <div class="inner-div" style="background-image: url({{card_values.img}});"></div>
                                <div class="info">
                                    <div class="info_content"><img src={{card_values.icon_img}}><br><p>{{card_values.domain}}</p></div>
                                 </div>
                              </div>
                            </div>
                            <div class="col-sm-10 head_col">
                                  <div class="row own_row">
                                    <div class="col-sm-10"></div>
                                    <div class="col-sm-2 own_col">Owned</div>
                                  </div>
                                  <div class="row head_data">
                                    <div class="col-sm-12 card_heading">
                                      <p>{{card_values.data}}</p>
                                    </div>
                                  </div>
                                  <div class="row head_data">
                                    <div class="col-sm-12 sub_data">
                                      <!-- <p>RAW</p> -->
                                    </div>
                                  </div>
                                  <div class="row head_data">
                                    <div class="col-sm-12 sub_data">
                                      <p>Order No: 11238-562123-117789</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        <div class="row product_details">
                          <div class="col-sm-12 sub_data">
                            <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis.</p>
                          </div>
                        </div>
                        <div class="row card_actions">
                          <div class="col-sm-12">
                          <div class="row">
                            <div class="col btn_col">
                            <a>
                              <div class="asset-btn">
                                <p>Download Asset<i class="fas fa-download"></i></p>
                              </div>
                            </a>
                          </div>
                          <div class="col btn_col">
                            <a>
                              <div class="invoice-btn">
                                <p>Download Invoice<i class="fas fa-download"></i></p>
                              </div>
                            </a>
                          </div>
                        </div>
                          </div>
                        </div>
                    </div>
                </div>


              
              <pagination-controls (pageChange)="p = $event" class="mt-4"></pagination-controls>

            </div>
           </div>
       </section>  
        <!-- begin::Sticky Toolbar -->
        <app-stickytoolbar></app-stickytoolbar>
        <!-- end::Sticky Toolbar -->       
     </div>
  </div>
</div>

